import i18n, { Ti18nKeys } from "../../../constants/i18n";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import { isBlankValue } from "../../../core/et3-field-grid";
import {
  FIELD_GRID_EMPTY_VALUE,
  FIELD_GRID_MONO_FONT_STACK
} from "../../../core/et3-field-grid/field-grid-constants";
import Et3Text from "../../../core/et3-text";
import { ROW_FACT_FONT_SIZE } from "./user-row/lanes/lane-constants";

const ApprovalFact = withLiteObserverAndTheme<{
  labelKey: Ti18nKeys;
  value: string;
  withLabel: boolean;
  isMachineValue: boolean;
}>((props) => {
  const { labelKey, value, withLabel, isMachineValue, theme } = props;
  const { colors, unitX } = theme;
  const isBlank = isBlankValue(value);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={0}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "auto",
        height: "auto",
        minHeight: 0,
        minWidth: 0,
        flexShrink: 0,
        gap: 6 * unitX
      }}
      onClick={() => {}}
    >
      {withLabel ? (
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={ROW_FACT_FONT_SIZE}
          text={i18n.get(labelKey)}
          isSpan={true}
          color={colors.all.davysGrey}
          style={{ margin: 0 }}
        />
      ) : null}
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={ROW_FACT_FONT_SIZE}
        text={isBlank ? FIELD_GRID_EMPTY_VALUE : value}
        isSpan={true}
        color={isBlank ? colors.all.gray : colors.all.maastrichtBlue}
        style={{
          margin: 0,
          whiteSpace: "nowrap",
          fontFamily: isMachineValue ? FIELD_GRID_MONO_FONT_STACK : undefined
        }}
      />
    </ET3Div>
  );
});
export default ApprovalFact;
